import {
    useEffect,
    useMemo,
    useState
} from "react";

import {
    Empty,
    message,
    Spin
} from "antd";

import {
    useParams
} from "react-router-dom";

import PdfView
    from "../../component/pdfView";

import FolderPdfView
    from "../../component/folderPdfView";

import {
    getReaderManifest
} from "../../api/myBook";

import {
    isMobileBooksOSDevice
} from "../../utils/booksOs";


const getApiBase = () =>
    String(
        process.env.REACT_APP_API_URL ||
        ""
    )
        .replace(
            /\/+$/,
            ""
        );


const absoluteReaderUrl =
    path => {

        if (!path) {
            return "";
        }

        if (
            /^https?:\/\//i.test(
                path
            )
        ) {
            return path;
        }

        const base =
            getApiBase();

        if (!base) {
            return path;
        }

        return (
            base +
            "/" +
            String(path)
                .replace(
                    /^\/+/,
                    ""
                )
        );
    };


export default function BookDetail() {

    const param =
        useParams();

    const requiresBooksOS =
        isMobileBooksOSDevice();

    const [reader, setReader] =
        useState(null);

    const [loading, setLoading] =
        useState(
            !requiresBooksOS
        );

    const user =
        JSON.parse(
            localStorage.getItem(
                "user"
            )
        );


    useEffect(() => {

        if (
            requiresBooksOS
        ) {
            return;
        }

        if (
            !param?.slug ||
            !user?.user_id
        ) {
            setLoading(
                false
            );

            return;
        }

        let active =
            true;

        setLoading(
            true
        );

        getReaderManifest(
            param.slug,
            user.user_id
        )
            .then(
                response => {

                    if (!active) {
                        return;
                    }

                    if (
                        response?.status ===
                        1
                    ) {
                        setReader(
                            response.data
                        );
                    } else {
                        setReader(
                            null
                        );

                        message.error(
                            response?.message ||
                            "Không thể mở tài liệu."
                        );
                    }
                }
            )
            .catch(
                error => {

                    if (!active) {
                        return;
                    }

                    setReader(
                        null
                    );

                    message.error(
                        error?.response
                            ?.data
                            ?.message ||
                        "Không thể mở tài liệu."
                    );
                }
            )
            .finally(
                () => {

                    if (active) {
                        setLoading(
                            false
                        );
                    }
                }
            );

        return () => {
            active =
                false;
        };

    }, [
        param?.slug,
        requiresBooksOS,
        user?.user_id
    ]);


    const folderFiles =
        useMemo(
            () =>
                (
                    reader?.files ||
                    []
                ).map(
                    file => ({
                        ...file,
                        url:
                            absoluteReaderUrl(
                                file.url
                            )
                    })
                ),
            [
                reader?.files
            ]
        );


    if (
        requiresBooksOS
    ) {

        return (
            <PdfView
                url={null}
                title="Tài liệu"
            />
        );
    }


    if (loading) {

        return (
            <div
                className="
                    min-h-[60vh]
                    flex
                    items-center
                    justify-center
                "
            >
                <Spin size="large" />
            </div>
        );
    }


    if (!reader) {

        return (
            <div
                className="
                    min-h-[50vh]
                    flex
                    items-center
                    justify-center
                "
            >
                <Empty
                    description="Không tìm thấy tài liệu hoặc bạn chưa có quyền đọc."
                />
            </div>
        );
    }


    if (
        reader.mode ===
        "folder"
    ) {

        return (
            <FolderPdfView
                title={
                    reader.title
                }
                files={
                    folderFiles
                }
            />
        );
    }


    return (
        <FolderPdfView
            title={
                reader.title ||
                "Tài liệu"
            }
            files={[
                {
                    id:
                        "single-document",

                    name:
                        reader.title ||
                        "Tài liệu",

                    kind:
                        "pdf",

                    url:
                        absoluteReaderUrl(
                            reader.url
                        )
                }
            ]}
        />
    );
}
